import DOMPurify from 'dompurify';

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node instanceof Element && node.getAttribute('target') === '_blank') {
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

/**
 * Sanitizes rich text authored in the admin WYSIWYG before it is injected with
 * dangerouslySetInnerHTML. `stripLinks` unwraps <a> (keeping its text), for
 * places that are themselves wrapped in a link.
 */
const sanitizeHtml = (html: string, { stripLinks = false } = {}) =>
  DOMPurify.sanitize(html, {
    ADD_ATTR: ['target'],
    ...(stripLinks ? { FORBID_TAGS: ['a'] } : {}),
  });

export default sanitizeHtml;
